// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"ef1eaad2","113":"57e7e1a4","159":"69053946","181":"db9ceb39","204":"012b9e8f","354":"4e62813d","481":"580db0fa","488":"8ff66fa9","657":"7a805e59","721":"cc26a68b","857":"c9221f4e","858":"2a7fd3d4","946":"8abd894c"}[chunkId] + ".chunk.js";
};